import React from "react";
import { Link } from "react-router-dom";

type Variant = "mark" | "horizontal" | "stacked";

interface Props {
  variant?: Variant;
  /** Pass null for a non-link lockup (e.g. hero). Defaults to "/". */
  to?: string | null;
  className?: string;
  light?: boolean;
}

const Monogram: React.FC<{ light?: boolean }> = ({ light }) => (
  <span className={`brand-monogram${light ? " brand-monogram-light" : ""}`} aria-hidden="true">
    <span className="brand-monogram-letters">TW</span>
  </span>
);

const BrandLogo: React.FC<Props> = ({
  variant = "horizontal",
  to,
  className = "",
  light = false,
}) => {
  const href = to === null ? null : to ?? "/";
  const classes = [
    "brand-logo",
    `brand-logo-${variant}`,
    light ? "brand-logo-light" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const inner =
    variant === "mark" ? (
      <Monogram light={light} />
    ) : variant === "stacked" ? (
      <>
        <div className="brand-logo-rule-row">
          <span className="brand-hairline" />
          <Monogram light={light} />
          <span className="brand-hairline" />
        </div>
        <span className="brand-wordmark">Ticketed Wedding</span>
        <span className="brand-tagline">Your presence is the present.</span>
        <span className="brand-parent">A Pash Company Brand</span>
      </>
    ) : (
      <>
        <Monogram light={light} />
        <span className="brand-wordmark">Ticketed Wedding</span>
      </>
    );

  if (href) {
    return (
      <Link to={href} className={classes} aria-label="Ticketed Wedding home">
        {inner}
      </Link>
    );
  }

  return (
    <div className={classes} aria-label="Ticketed Wedding">
      {inner}
    </div>
  );
};

export default BrandLogo;
